import { check_if_in_range as e } from "../../../utilities/index.js";
import { ad2bs as t } from "../../../calendar-carburettor/converter/index.js";
import { isDateInConversionRange as n } from "../../../calendar-carburettor/is-date-in-conversion-range/index.js";
import { stitch_date as r } from "../../utilities/stitch_date.js";
import { get_first_day_of_the_month as i } from "./get_first_day_of_the_month.js";
import { is_today as a } from "./is_today.js";
import { ENGLISH_DATE as o } from "./index.js";
import s from "dayjs";
import { englishToNepaliNumber as c } from "nepali-number";
import l from "dayjs/plugin/isBetween";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/get_day_info.ts
s.extend(l);
var u = t, d = ({ calendarReferenceDate: t, weekDayNum: l, weekNum: d, disable_date_after: f, disable_date_before: p, disabledWeekDays: m, holidays: h, date: g, weekSelectionEnabled: _, weekAnchorDate: v }) => {
	let y = t, b = g, x = y ? s(y).format("YYYY-MM-DD") : s().format("YYYY-MM-DD"), S = new Date(x), C = i(S), w = d * 7 + l - C, T = S.getMonth() + 1, E = S.getFullYear(), D = o.get_total_days_in_month(new Date(x)), O = !0;
	if (w <= 0) {
		E = T === 1 ? E - 1 : E, T = T === 1 ? 12 : T - 1, O = !1;
		let e = r({
			year: E,
			month: T,
			day: 1
		});
		w = o.get_total_days_in_month(new Date(e)) + w;
	} else w > D && (E = T === 12 ? E + 1 : E, T = T === 12 ? 1 : T + 1, w -= D, O = !1);
	let k = r({
		year: E,
		month: T,
		day: w
	}), A = "X-X-X";
	n(k, !1) && (A = u(k));
	let [j, M, N] = A ? A.split("-") : [], P = a(new Date(k)), F = !1;
	_ && v ? F = s(k).isSame(s(v), "week") : b && (F = s(k).isSame(s(b), "day"));
	let I = (m ?? []).includes(l) || (h ?? []).includes(k), L = e(k, p, f), R = !O || !L || I;
	return {
		workingDay: w,
		workingMonth: T,
		workingYear: E,
		primaryDay: w,
		primaryMonth: T,
		primaryYear: E,
		secondaryYear: j === "X" ? j : c(parseInt(j)),
		secondaryMonth: M === "X" ? j : c(parseInt(M)),
		secondaryDay: N === "X" ? j : c(parseInt(N)),
		isCurrentMonth: O,
		isToday: P,
		isSelected: F,
		isDisabled: R,
		isDayOff: I
	};
};
export { d as get_day_info };

//# sourceMappingURL=get_day_info.js.map